/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@constants/global-objects.constants';
import { DATA_LAYER } from '@constants/gtm.constants';
import { GtmPayload } from 'src/app/interfaces/gtm-interface';

@Injectable({
  providedIn: 'root',
})
export class GtmEventService {
  constructor(@Inject(WINDOW) private readonly window: Window) {}

  public dispatch(payload: GtmPayload): void {
    this.window[DATA_LAYER] = this.window[DATA_LAYER] || [];
    this.window[DATA_LAYER].push(payload);
  }
}
